import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Row } from "reactstrap";
import * as R from "ramda";
import {
  sap2AccountingKey,
  sap2Society,
  sap2Division,
  sap2ClaimingArea,
  accountingKeySign
} from "../../../../utils/sap-mapper";
import TextSection from "./text-section";
import SelectSection from "./select-section";
import NumericSection from "./numeric-section";

const ClientForm = ({
  currency,
  showError,
  canEdit,
  isEditing,
  editingObject,
  sapCode,
  society: defaultSociety,
  division: defaultDivision,
  isValidChange,
  onValueChanged
}) => {
  const [customer, setCustomer] = useState(isEditing ? editingObject.customer : sapCode);
  const [accountingKey, setAccountingKey] = useState(isEditing ? editingObject.accountingKey : -1);
  const [amount, setAmount] = useState(isEditing ? editingObject.amount : 0);
  const [society, setSociety] = useState(isEditing ? editingObject.society : defaultSociety);
  const [division, setDivision] = useState(isEditing ? editingObject.division : defaultDivision);
  const [recArea, setRecArea] = useState(isEditing ? editingObject.recArea : " ");
  const [observaciones, setObservaciones] = useState(isEditing ? editingObject.observaciones : " ");
  const [isValidAmount, setIsValidAmount] = useState(true);
  useEffect(() => {
    const submitActive =
      !R.isEmpty(customer) &&
      accountingKey !== -1 &&
      accountingKey !== "-1" &&
      amount > 0 &&
      society !== -1 &&
      society !== "-1" &&
      division !== -1 &&
      division !== "-1" &&
      isValidAmount;
    isValidChange(submitActive);
  }, [accountingKey, amount, customer, division, society, isValidAmount, isValidChange]);
  useEffect(
    () =>
      onValueChanged({
        customer,
        accountingKey,
        amount,
        society,
        division,
        recArea,
        observaciones
      }),
    // eliminamos la referencia a onValueChanged para evitar infinitos renderizados
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [accountingKey, amount, customer, division, recArea, society, observaciones]
  );

  return (
    <div>
      <Row>
        <div className="col-12">
          <h4>Datos de cliente</h4>
        </div>
        <TextSection
          required
          showError={showError}
          title="Cód SAP"
          value={customer}
          onChange={newValue => setCustomer(newValue)}
          canEdit={canEdit}
          maxLength={10}
        />
      </Row>
      {/* Item data */}
      <Row>
        <div className="col-12 mt-4">
          <h4>Datos de la partida</h4>
        </div>
        <SelectSection
          required
          showError={showError}
          title="Clave contable"
          onChange={newValue => {
            setAccountingKey(newValue);
            if (newValue === "-1") {
              setSociety(newValue);
              setDivision(newValue);
              setRecArea(newValue);
            }
          }}
          value={accountingKey}
          options={Object.entries(sap2AccountingKey).map(entry => (
            <option value={entry[0]} selected={accountingKey === entry[0]}>
              {`${entry[0]}: ${entry[1]}`}
            </option>
          ))}
          canEdit={canEdit}
        />
        <NumericSection
          required
          append={currency}
          showError={showError}
          title="Importe"
          negativePrepend={accountingKeySign(accountingKey) < 0}
          value={amount}
          onChange={newValue => setAmount(newValue)}
          canEdit={canEdit}
          isValidChange={newValue => setIsValidAmount(newValue)}
        />
        <SelectSection
          required
          title="Sociedad"
          onChange={newValue => {
            setSociety(newValue);
            setRecArea(" ");
          }}
          showError={showError}
          value={society}
          options={Object.entries(sap2Society).map(entry => (
            <option value={entry[0]} selected={society === entry[0]}>
              {`${entry[0]}: ${entry[1]}`}
            </option>
          ))}
          canEdit={canEdit}
        />
        <SelectSection
          required
          showError={showError}
          title="División"
          onChange={newValue => setDivision(newValue)}
          value={division}
          options={Object.entries(sap2Division).map(entry => (
            <option value={entry[0]} selected={division === entry[0]}>
              {`${entry[0]}: ${entry[1]}`}
            </option>
          ))}
          canEdit={canEdit}
        />
        <SelectSection
          title="Área de reclamación"
          onChange={newValue => setRecArea(newValue)}
          value={recArea}
          options={Object.entries(sap2ClaimingArea(society)).map(entry => (
            <option value={entry[0]} selected={recArea === entry[0]}>
              {`${entry[0]}: ${entry[1]}`}
            </option>
          ))}
          required={false}
          canEdit={canEdit}
        />
        <TextSection
          title="Observaciones"
          onChange={newValue => setObservaciones(newValue)}
          value={observaciones}
          canEdit={canEdit}
          isMultiline
          required={false}
        />
      </Row>
    </div>
  );
};
ClientForm.propTypes = {
  currency: PropTypes.string,
  sapCode: PropTypes.string,
  society: PropTypes.number,
  division: PropTypes.number,
  isEditing: PropTypes.bool,
  editingObject: PropTypes.shape({
    amount: PropTypes.number,
    customer: PropTypes.string,
    society: PropTypes.string,
    division: PropTypes.string,
    recArea: PropTypes.string,
    accountingKey: PropTypes.string,
    observaciones: PropTypes.string
  }),
  canEdit: PropTypes.bool,
  isValidChange: PropTypes.func,
  onValueChanged: PropTypes.func,
  showError: PropTypes.bool
};

ClientForm.defaultProps = {
  currency: "EUR",
  showError: false,
  sapCode: "",
  society: -1,
  division: -1,
  isEditing: false,
  editingObject: {
    observaciones: ""
  },
  canEdit: true,
  isValidChange: () => {},
  onValueChanged: () => {}
};
export default ClientForm;
